import {
    Select,
    MenuItem,
    SelectChangeEvent,
    SxProps,
    Theme,
    Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { availableLanguages, flags, eLanguages, defaultLanguage } from "../../i18n";
import moment from "moment";
import "moment/min/locales";
import AuthService from "../../services/auth/AuthService";
import { ELanguage } from "../../models/enums/language";
import userService from "../../services/user/UserService";
interface LanguageSelectorProps {
    sx?: SxProps<Theme>;
    borderDisabled?: boolean;
    isUserConnected?: boolean
}
const LanguageSelector = ({
    sx,
    borderDisabled = false,
    isUserConnected = true
}: LanguageSelectorProps) => {
    const { i18n } = useTranslation();

    const languageSelected = async (event: SelectChangeEvent<string>) => {
        i18n.changeLanguage(event.target.value);
        moment.locale(event.target.value);
        AuthService.setLanguage(
            eLanguages.get(event.target.value) || defaultLanguage
        );
        isUserConnected && await userService.PutUserUpdate({ language: eLanguages.get(event.target.value) || defaultLanguage })
    };

    return (
        <>
            <Select
                sx={
                    borderDisabled
                        ? {
                            ...sx,
                            boxShadow: "none",
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                        }
                        : { ...sx }
                }
                value={i18n.language}
                onChange={(event) => languageSelected(event)}
                defaultValue={i18n.language}
            >
                {availableLanguages.map((lang) => (
                    <MenuItem key={lang} value={lang}>
                        <Box display="flex">
                            <img src={flags.get(lang)} height="15em" />
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </>
    );
};

export default LanguageSelector;
